import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CaseProduct } from '../../../mortgage-application/models/case-product.model';
import { FormProductSelectionComponent } from '../../../shared/components/form-inputs/form-product-selection/form-product-selection.component';
import { Product } from './../../../../lib/models/api/product.model';
import { Kfi } from './../../models/kfi.model';

@Component({
  selector: 'boi-form-kfi-product-selection',
  templateUrl: '../../../shared/components/form-inputs/form-product-selection/form-product-selection.component.html',
  styleUrls: ['../../../shared/components/form-inputs/form-product-selection/form-product-selection.component.scss']
})
export class FormKfiProductSelectionComponent extends FormProductSelectionComponent implements OnInit, OnChanges {
  @Input() public kfi: Kfi;

  public get selectionType(): string {
    return this.kfi.ProductSelectionTypeCode;
  }

  public set selectionType(value: string) {
    this.kfi.ProductSelectionTypeCode = value;
  }

  public get partAndPartRepaymentCaseProduct(): CaseProduct {
    return this.kfi.CaseProducts[1];
  }

  public get isPartAndPartRepaymentType(): boolean {
    return this.kfi.CaseProducts.length > 1;
  }

  protected setFormApplicationLoanTypeCode(): void {
    this.kfi.LoanTypeCode = this.product.LoanTypeCode;
  }

  public ngOnInit(): void {
    this.initializeSelectionType();
    this.initialize();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.kfi && changes.kfi.currentValue) {
      this.caseNumberAsHash = this.kfi.ApplicationCase.CaseNumberAsHash;
      this.caseProduct = this.kfi.CaseProducts[0];
      this.isBuyToLet = this.kfi.isBuyToLet;
      this.isBrokerCase = this.kfi.isBrokerApplication;
      this.initializeSelectionType();
      this.initializeProductRelatedFields();
      this.setProductExpirationFlags();
    }
  }

  protected getProductByProductCode(): Observable<Product> {
    return this.productService.getProductByProductCode(this.kfi, this.productCode);
  }

  protected getProductsByLoanType(): Observable<Array<Product>> {
    return this.productService.getProductsByLoanType(this.kfi, this.selectedLoanType);
  }

  protected getProductWarningMessage(): string {
    return this.getProductStatusWarning(
      this.product,
      this.referenceDataLabels.ProductWithdrawnKFI,
      this.referenceDataLabels.ProductAboutToExpireKfi
    );
  }

  protected selectNewProduct(): void {
    super.selectNewProduct();

    if (this.isNewProductSelected() && this.allowsExpiredProduct) {
      this.productService
        .getProductByCodeIncludingExpired(this.kfi, this.productCode)
        .pipe(takeUntil(this.destroySubject$))
        .subscribe(
          (product) => {
            this.setCurrentProduct(product);
            this.initializeProductRelatedFields();
            this.setProductExpirationFlags();
          },
          () => {
            this.removeSelectedProductAndKeepProductCode();
            this.cdr.detectChanges();
          }
        );
    }
  }

  private initializeSelectionType(): void {
    this.selectionType = this.kfi.AllowsExpiredProduct
      ? this.referenceDataOptionLists.ProductSelectionByCode
      : this.kfi.ProductSelectionTypeCode || this.referenceDataOptionLists.ProductSelectionByType;
  }
}
